import React, {useContext} from "react";
import emoji from "react-easy-emoji";
import StyleContext from "../../contexts/StyleContext";
import "./ToggleSwitch.scss";

const ToggleSwitch = () => {
  const {language, changeLanguage} = useContext(StyleContext);
  // 'es' means checked (Spanish), 'en' means unchecked (English)
  const isSpanish = language === "es";

  return (
    <label className="switch">
      <input
        type="checkbox"
        checked={isSpanish}
        onChange={() => {
          changeLanguage();
        }}
      />
      <span className="slider round">
        <span className="emoji">{isSpanish ? emoji("🇪🇸") : emoji("🇺🇸")}</span>
      </span>
    </label>
  );
};
export default ToggleSwitch;
